module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/iphonexr_splash-0ed6511397a83bbdde9ed95928fe5c44.png";